import { BaseCard } from '@/shared/components'

type Props = {
  children: React.ReactNode
  title: string
}

export const BaseProfileCard = ({ children, title }: Props) => {
  return (
    <BaseCard
      variant="secondary"
      className="flex flex-col flex-6 2xl:flex-6 xl:flex-1 gap-8 px-5 md:px-6 pt-6 pb-10 text-text-secondary dark:text-white"
    >
      <p className="pb-4 border-b border-b-card-border dark:border-b-card-border-dark">{title}</p>
      {children}
    </BaseCard>
  )
}
